<template>
  <div>
    <v-row>
      <v-col>
        <v-data-table
            :headers="tabla.headers"
            :items="tabla.items"
            :options.sync="tabla.options"
            :server-items-length="tabla.count"
            :fixed-header="true"
            class="elevation-3"
            calculate-widths
            :footer-props="{ itemsPerPageOptions: [5, 10, 20, 50], itemsPerPageText: $t('Registros por página') }"
            :no-data-text="$t('No hay datos')"
            :no-results-text="$t('No hay datos')"
            :hide-default-footer="hide_footer"
        >
          <template v-slot:item="{ item }">

            <tr>
              <td>{{ item.fecha | moment('DD/MM/YYYY HH:mm') }}</td>
              <td>{{ item.descripcion }}</td>
              <td>{{ item.importe | money }}</td>
              <td>{{ item.forma_pago }}</td>
              <td>{{ item.created_by }}</td>
              <td>
                <ToolTipVenta
                    v-if="item.venta"
                    :venta="item.venta"
                />
              </td>
              <td style="text-align: center">
                <v-btn icon color="primary" @click="imprimir(item.id)">
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
              </td>
              <td class="text-center" v-if="hide_delete_button">
                <v-btn :title="$t('Eliminar abono de deuda')" icon
                       @click="$emit('on_delete_movimiento_deuda', item)">
                  <v-icon color="red">mdi-delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>


<script>
import { ref, watch } from '@vue/composition-api'
import useTable from "@/composables/useTable"

export default {
  name: 'TablaMovimientosDeuda',
  props: {
    // Filtros para realizar la búsqueda
    selected_filters: {
      type: Object,
      default: {},
      required: true
    },
    refresh:0,
    hide_footer: {
      type: Boolean,
      default: false
    },
    hide_delete_button: {
      type: Boolean,
      default: false
    }
  },

  methods:{
    async refresh_items() {
      this.get_movimientos();
      this.$emit('has_refreshed')
    },

    imprimir(movimiento_id) {
      window.open(this.$router.resolve({name: 'print_abono_deuda', params: {id: movimiento_id}}).href, '_blank')
    }
  },

  setup(props, {root}){

    const {tabla, get_items} = useTable('caja/get_movimientos_cliente_caja')

    const get_movimientos = () => {
      let filtros = { ...tabla.filtros, ...props['selected_filters'], ...{'ordering': '-fecha'} }
      get_items(filtros)
    }

    tabla.filtros

    get_movimientos()

    tabla.value.headers = [
      { text: root.$t('Fecha'), value: 'fecha', class: "primary white--text" },
      { text: root.$t('Descripción'), value: 'descripcion', class: "primary white--text" },
      { text: root.$t('Importe'), value: 'importe', class: "primary white--text" },
      { text: root.$t('Forma de pago'), value: 'forma_pago', class: "primary white--text" },
      { text: root.$t('Empleado'), value: 'created_by', class: "primary white--text" },
      { text: root.$t('Venta'), value: 'venta', class: "primary white--text", sortable: false, width: "80px" },
      { text: '', value: 'actions', class: "primary white--text", sortable: false, align: 'left' }
    ]

    return {
      tabla,
      get_movimientos,
    }
  },

  mounted () {
    if (this.hide_delete_button === true) {
      this.tabla.headers.push(
          { text: '', value: 'actions', class: 'primary white--text', sortable: false, align: 'left' })
    }
  },

  watch: {
    'refresh': {
      handler(){
        if(this.refresh){
          this.refresh_items()
        }
      }
    }
  },
  components: {
    ToolTipVenta: () => import('@/views/Ventas/components/ToolTipVenta')
  }
}
</script>
